"use client"
import { Dialog, DialogContent} from "@/components/ui/dialog"
export default function Modal({ open, onOpenChange, children, ...props}) {
    return (
        <Dialog open={open} onOpenChange={onOpenChange} {...props}>
            <DialogContent className="sm:max-w-md [&>button:last-child]:hidden">
                {children}
            </DialogContent>
        </Dialog>
    )
}
